"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeLinkHandler = exports.NativeLinkClient = exports.MatchFilter = void 0;
const uuid_1 = require("uuid");
const MatchFilter = (filter, obj) => {
    for (let key in filter) {
        if (filter[key] !== obj[key])
            return false;
    }
    return true;
};
exports.MatchFilter = MatchFilter;
class NativeLinkClient {
    constructor() {
        this.DefaultTimeout = 1000;
        this.RegisterMessageClient = (msgClient) => {
            this._MessageClient = msgClient;
            this._MessageClient.OnMessage = this.HandleMessage;
        };
        this.WaitForEvent = (filter = {}, timeout = this.DefaultTimeout) => {
            let eventPromise = new Promise((resolve, reject) => {
                //Race response and timeout (1 second)
                this.PendingEvents = [
                    ...this.PendingEvents,
                    { CompleteEvent: resolve, Filter: filter }
                ];
                setTimeout(() => {
                    reject("Native Link Response Error: Timeout");
                }, timeout);
            });
            return eventPromise;
        };
        this.Handlers = {};
        this.HandleMessage = async (msg) => {
            if (this._Logging) {
                this._Logging(msg);
            }
            try {
                let eventData = JSON.parse(msg);
                let eventTopic = eventData.EventTopic;
                if (eventTopic) {
                    let pendingEvent = this.PendingEvents.find(x => (0, exports.MatchFilter)(x.Filter, eventData));
                    if (pendingEvent) {
                        pendingEvent.CompleteEvent(eventData);
                        this.PendingEvents = this.PendingEvents.filter(x => x !== pendingEvent);
                        return;
                    }
                    let handler = this.Handlers[eventTopic];
                    if (handler) {
                        await handler.HandleEvent(eventData);
                    }
                }
            }
            catch (e) { }
        };
        this.SubmitEvent = async (eventSetup) => {
            let requestEvent = Object.assign({ EventId: (0, uuid_1.v4)(), EventType: "Request" }, eventSetup);
            if (this._MessageClient)
                await this._MessageClient.SendMessage(JSON.stringify(requestEvent));
        };
        this.SubmitEventWithResponse = async (eventSetup, timeout = this.DefaultTimeout) => {
            let requestEvent = Object.assign({ EventId: (0, uuid_1.v4)(), EventType: "Request" }, eventSetup);
            //wait for an event with the matching Id but response type
            let responsePromise = this.WaitForEvent({ EventId: requestEvent.EventId, EventType: "Response" }, timeout);
            if (this._MessageClient)
                await this._MessageClient.SendMessage(JSON.stringify(requestEvent));
            let myResult = await responsePromise;
            return myResult;
        };
        this.RegisterHandler = (key, handler) => {
            this.Handlers[key] = handler;
        };
        this.PendingEvents = [];
    }
}
exports.NativeLinkClient = NativeLinkClient;
class NativeLinkHandler {
    constructor(client) {
        this._Client = client;
    }
}
exports.NativeLinkHandler = NativeLinkHandler;
//# sourceMappingURL=NativeLinkContext.js.map